import * as React from 'react'
import { Route } from 'react-router'
import type { Rout_EnterHook } from './Rout.ReactRouter'

export function Rout_create(
    path: string,
    component: React.ComponentType<any>,
    onEnter?: Rout_EnterHook<any, any, any>
) {
    return <Route key={path} path={path} component={component} onEnter={onEnter} />
}
